// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import PipAffectedPins from './pip-affected-pins';
import PipDetailsHeader from './pip-details-header';
import PipDetailsModel from '@deere/cps-it.warranty-model-factory/lib/pip-details';
import PipDetailsPanel from './pip-details-panel';
import SearchFilters from '../../pip-details/state/search-filters';
import State from '../state';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import filterOptions from '../state/affected-pin-filter-options';

class PipDetails extends Component {

    componentWillMount() {

        if (this.props.queryParams.pin || this.props.queryParams.filter) {

            this.props.actions.updateListFilterBy(this.props.queryParams.pin, State);

        }

        if (this.props.queryParams.responsibleAccount) {

            this.props.actions.updateListFilterBy(this.props.queryParams.responsibleAccount, State);

        }

        this.props.actions.readPipDetails(this.props.routeParams.pipId);

    }

    componentWillUnmount() {

        this.props.actions.updateListFilterBy('', State);
        this.props.actions.resetPipDetails();

    }

    render() {

        let sortedCollection;

        sortedCollection = [...this.props.pipDetails.affectedPins];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, filterOptions, sortedCollection);

        return (
            <section className='pip-details'>
                <WarrantyLoadingIndicator
                    isLoading={this.props.busyCounter > 0}
                />
                <PipDetailsHeader
                    pipId={this.props.pipDetails.pipId}
                    title={this.props.pipDetails.description}
                />
                <main className='pip-details-main'>
                    <PipDetailsPanel pipDetails={this.props.pipDetails}/>
                    <PipAffectedPins
                        actions={this.props.actions}
                        affectedPins={sortedCollection}
                        busyCounter={this.props.busyCounter}
                        daysLeft={this.props.pipDetails.daysLeft}
                        metric={this.props.pipDetails.metric.key}
                        pipId={this.props.pipDetails.pipId}
                        searchFilters={this.props.searchFilters}
                        user={this.props.user}
                    />
                </main>
            </section>
        );

    }

}

PipDetails.displayName = 'PipDetails';
PipDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    pipDetails: PropTypes.instanceOf(PipDetailsModel).isRequired,
    queryParams: PropTypes.object.isRequired,
    routeParams: PropTypes.object.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default PipDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/index.js